import { useTheme } from "@material-ui/core/styles";

export type BrandColors = {
  // The app's action colour: links, selected tabs, primary buttons.
  primary: string;
  pageBackground: string;
};

export const useBrandColors = (): BrandColors => {
  const { palette } = useTheme();
  return { primary: palette.primary.main, pageBackground: palette.background.default };
};
